import { Component, Watch, Vue } from 'vue-property-decorator';
import AirCompanys from '../../ts/airCompany';
// 引用API文件
import api from '../../../api/api';

@Component({

})
export default class changeAirport extends Vue {

    // 全部航司
    private static allAirCompanys: { [key: string]: string; } = AirCompanys;
    // 全部机场
    private static allAirports: { [key: string]: any; } = {};
    // 证件类型
    private static certificates: { [key: string]: string; } = {
        'NI': '身份证',
        'PP': '护 照',
        'HX': '回乡证',
        'TB': '台胞证',
        'GA': '港澳通行证',
        'HY': '国际海员证',
        'ID': '其他',
    };
    // 乘客类型
    private static passengerType: { [key: string]: string; } = {
        'ADT': '成人',
        'CHD': '儿 童',
        'INF': '婴儿',
    };

    public static async initalize() {
        const result = await api.httpGet('Membership/TripBookTicket/GetAirportsDic', null);
        if (result.Success) {
            for(let key in result.Data ){
                result.Data[key]  = result.Data[key].map(function (item: any) {
                    return {
                        airportCode: item.AirportCode,
                        airportCName: item.AirportCName,
                        cityCode: item.CityCode,
                        cityCName: item.CityCName,
                        isHot: item.IsHot,
                        domesticProvince: item.DomesticProvince,
                    };
                });
            }
            
            this.allAirports = result.Data;
        }
    }

    // 三字码转换为机场详细信息
    public static changeAirportCode(airCode: any) {
        let airCitys = []; // 机场数组
        let airInfo: any = {};
        // 首先转换为机场数组
        for (let i in this.allAirports) {
            airCitys.push({ Key: i, Value: this.allAirports[i] });
        }
        airCitys.forEach(function (airs) {
            let result = airs.Value.find(function (air: any) {
                return air.airportCode == airCode;
            })
            if (result != undefined) {
                airInfo = result;
                return false;
            }
        })
        return airInfo;
    };

    // 航司简称转换为航班名称
    public static changeAirCompany(airCode: string) {
        // 航司数据源
        for (let i in this.allAirCompanys) {
            if (i === airCode) {
                return this.allAirCompanys[i];
            };
        }
    };

    // 证件类型转换
    public static changeCertificates(val: any) {
        for (let i in this.certificates) {
            if (i === val) {
                return this.certificates[i]
            };
        }
    };

    // 乘客类型转换
    public static changePassengerType(val: any) {
        for (let i in this.passengerType) {
            if (i === val) {
                return this.passengerType[i]
            };
        }
    };
}

changeAirport.initalize();
